import { createFileRoute } from '@tanstack/react-router'
import { zodValidator } from '@tanstack/zod-adapter'

import { z } from 'zod'

import {
	Divider,
	Link,
	Subtitle,
	Title,
} from '@/shared/auth/components/common/card'
import { AuthErrorComponent } from '@/shared/auth/components/common/error-component'
import { PasswordResetFlow } from '@/shared/auth/components/forms/password-reset-flow'

import { Button } from '@/components/ui/button'

const searchSchema = z.object({
	email: z.string().optional(),
})

export const Route = createFileRoute('/_auth/new-password-required')({
	validateSearch: zodValidator(searchSchema),

	head: () => ({
		meta: [
			{
				title: 'New Password Required | BitLyft AIR®',
			},
		],
	}),

	component: RouteComponent,
	errorComponent: AuthErrorComponent,
})

function RouteComponent() {
	const { email } = Route.useSearch()

	return (
		<>
			<Title>New Password Required</Title>
			<Subtitle>
				Your password needs to be reset before you can continue.
			</Subtitle>

			<PasswordResetFlow
				initialEmail={email}
				autoStart
				bannerMessage="Your password needs to be reset"
			/>

			<Divider />

			<Button
				variant="link"
				nativeButton={false}
				className="dark:text-primary-foreground"
				render={<Link to="/login">Return to Sign In</Link>}
			/>
		</>
	)
}
